export default {
  tab: 'Avis',
  toolbar: {
    markup: 'Annoter',
    record: 'Enregistrer',
    hint: 'Cliquer pour commenter, glisser pour dessiner',
    hintTouch: 'Faites glisser pour marquer le problème',
    hintRecord: "Enregistrement de l'écran",
    exit: 'Quitter',
  },
  popup: {
    about: 'À propos',
    placeholder: 'Décrivez le problème ou votre suggestion...',
    submit: 'Envoyer',
    sending: 'Envoi en cours...',
    cancel: 'Annuler',
    close: 'Fermer',
    my_feedback: 'Mes avis',
    screenshot_label: 'Joindre une capture d\'écran',
    screenshot_hint: 'Les mots de passe et autres champs sensibles sont masqués automatiquement.',
    screenshot_short: 'Capture',
    screenshot_locked_hint: "Votre dessin est intégré à la capture, elle est donc toujours jointe. Les champs sensibles sont masqués automatiquement.",
    recording_label: 'Enregistrement',
    recording_locked_hint: "Une relecture de ce que la page affichait et de son utilisation — toujours jointe. Ni caméra ni micro. Les champs sensibles sont masqués automatiquement.",
    quickOptions: [
      { emoji: '🐛', label: 'Bug', value: 'Quelque chose ne fonctionne pas' },
      { emoji: '💡', label: 'Suggestion', value: "J'ai une suggestion" },
      { emoji: '🤔', label: 'Confus', value: 'Je suis perplexe' },
    ],
  },
  success: {
    title: 'Merci, votre retour est bien arrivé.',
    title_no_ai: 'Merci ! Nous avons bien reçu votre avis.',
    close: 'Fermer',
    email_saved: 'Vous recevrez un e-mail une fois résolu.',
    email_error: "Impossible d'enregistrer votre e-mail. Veuillez réessayer.",
    track_feedback: 'Suivre mon retour',
    email_cta: 'M’avertir par e-mail une fois corrigé',
    notify: 'Avertir',
  },
  error: {
    submit: "Échec de l'envoi. Veuillez réessayer.",
    finalize_title: "Nous n'avons pas encore pu l'envoyer.",
    finalize_message: 'Votre retour est toujours enregistré. Veuillez réessayer.',
  },
  pet: {
    bubble: "Besoin d'aide ?",
  },
  frustration: {
    prompt: 'Un problème ? Dites-le-nous.',
    action: 'Annoter',
    dismiss: 'Fermer',
  },
  annotation: {
    drawing: 'Dessin',
    element: 'élément',
  },
  draw: {
    note_placeholder: 'Ajoutez une note à votre dessin',
    undo: 'Annuler',
    redo: 'Rétablir',
    cancel: 'Annuler',
    submit: 'Envoyer',
  },
  record: {
    stop: 'Arrêter',
    timer_label: 'Enregistrement',
    max_reached: "Durée maximale d'enregistrement atteinte",
    replay_label: 'screen-recording.json',
    play: "Lire l'enregistrement",
    close: 'Fermer',
    preview_unavailable: 'Aperçu indisponible',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: 'Affinement de votre retour',
    thinking: 'Réflexion...',
    placeholder: 'Ajoutez des détails, puis envoyez',
    send: 'Envoyer',
    submit: 'Soumettre',
    send_feedback: 'Envoyer le retour',
    skip: 'Ignorer et envoyer',
    skip_short: 'Ignorer',
    cancel: 'Annuler — ne pas envoyer',
    retry: 'Réessayer',
    error: 'Impossible de charger la question. Envoyez votre avis tel quel.',
    expired: 'Cette session de retour a expiré avant d\'avoir pu être envoyée. Fermez le widget et renvoyez-la.',
  },
}
